<!--
  ~ Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
  ~ This software is released under MIT license.
  ~ The full license information can be found in LICENSE in the root directory of this project.
  -->

<div
  #contentContainer
  role="treeitem"
  class="clr-tree-node-content-container"
  tabindex="-1"
  [attr.aria-expanded]="isExpandable() ? expanded : null"
  [attr.aria-selected]="ariaSelected"
  (keydown)="onKeyDown($event)"
  (focus)="broadcastFocusOnContainer()"
>
  <button
    *ngIf="isExpandable() && !isModelLoading && !expandService.loading"
    aria-hidden="true"
    type="button"
    tabindex="-1"
    class="clr-treenode-caret"
    (click)="expandService.toggle();"
    (focus)="focusTreeNode()"
  >
    <cds-icon
      class="clr-treenode-caret-icon"
      shape="angle"
      [attr.direction]="expandService.expanded ? 'down' : 'right'"
    ></cds-icon>
  </button>
  <div class="clr-treenode-spinner-container" *ngIf="expandService.loading || isModelLoading">
    <span class="clr-treenode-spinner spinner"></span>
  </div>
  <div class="clr-checkbox-wrapper clr-treenode-checkbox" *ngIf="featuresService.selectable">
    <input
      aria-hidden="true"
      type="checkbox"
      id="{{nodeId}}-check"
      class="clr-checkbox"
      [checked]="_model.selected.value === STATES.SELECTED"
      [indeterminate]="_model.selected.value === STATES.INDETERMINATE"
      (change)="_model.toggleSelection(featuresService.eager)"
      (focus)="focusTreeNode()"
      tabindex="-1"
    />
    <label for="{{nodeId}}-check" class="clr-control-label"></label>
  </div>
  <div class="clr-treenode-content" (mousedown)="focusTreeNode()">
    <ng-content></ng-content>
    <div class="clr-sr-only" *ngIf="featuresService.selectable || ariaSelected">
      <span *ngIf="ariaSelected"> selected</span>
      <span *ngIf="!ariaSelected"> unselected</span>
    </div>
  </div>
</div>
<div
  class="clr-treenode-children"
  [@toggleChildrenAnim]="expandService.expanded ? 'expanded' : 'collapsed'"
  [attr.role]="isExpandable() && !featuresService.recursion ? 'group' : null"
>
  <ng-content select="clr-tree-node"></ng-content>
  <ng-content select="[clrIfExpanded]"></ng-content>
  <clr-recursive-children [parent]="_model"></clr-recursive-children>
</div>
